import React from "react";
import { useTranslation } from "react-i18next";
import { FaGlobe } from "react-icons/fa";
import { useLanguageModal } from "../LanguageModalProvider/LanguageModalProvider";

interface LanguageSwitcherProps {
  className?: string;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  className = "",
}) => {
  const { i18n } = useTranslation();
  const { openLanguageModal } = useLanguageModal();

  return (
    <button
      onClick={openLanguageModal}
      className={`flex items-center gap-2 md:px-4 md:py-2 rounded-lg hover:text-gray-300 transition-colors text-primary ${className}`}
    >
      <FaGlobe size={20} />
      <span>{i18n.language === "es" ? "ES" : "EN"}</span>
    </button>
  );
};

export default LanguageSwitcher;
